import {Component} from '@angular/core';
import {NavbarComponent} from '../../components/navbar/navbar.component';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {NewsItemComponent} from "../../components/news-item/news-item.component";
import {NgForOf} from "@angular/common";
import {NewsItemDto} from "../../contracts/news-item.dto";
import {NewsService} from '../../services/news/news.service';
import {EventsBaseComponent} from "../../shared/events-base.component";

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [TranslateModule, NavbarComponent, NewsItemComponent, NgForOf],
  templateUrl: './news.component.html'
})
export class NewsComponent extends EventsBaseComponent<NewsItemDto> {

  constructor(
    languageService: TranslateService,
    private newsService: NewsService
  ) {
    super(languageService);
    this.evService = this.newsService;
    this.items = this.newsService.getEvents().filter(x => x.private != true);
  }

}
